import React from 'react'
import styles from './InvoiceCard.module.css'

const DownloadIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const InvoiceCard = ({
  invoiceNo,
  status = 'paid', // 'paid' | 'unpaid'
  date,
  time,
  reason,
  minutes,
  // "Minutes Used" for invoices where real usage was billed (threshold /
  // month-end); "Minutes" for a plan-purchase invoice, where the number is the
  // plan's allowance, not minutes actually used.
  minutesLabel = 'Minutes Used',
  amount,
  note,
  onDownload,
  onPrimary,
  busy = false,      // this invoice's "Try Again" is charging
  message,           // result/status text shown under the actions
}) => {
  const isUnpaid = status === 'unpaid'

  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <h4 className={styles.invoiceNo}>Invoice #{invoiceNo}</h4>
        <span className={`${styles.badge} ${isUnpaid ? styles.unpaid : styles.paid}`}>
          {isUnpaid ? 'Unpaid' : 'Paid'}
        </span>
      </div>

      <p className={styles.datetime}>
        {date} <span className={styles.dot}>•</span> {time}
      </p>
      <p className={styles.reason}>Reason: {reason}</p>

      <div className={styles.metrics}>
        {/* Minutes block only when there's a value. A later PAYG $5-fee invoice
            with no usage has no minutes (free 50 is first-month only), so the
            whole Minutes section is hidden rather than showing an empty label. */}
        {minutes ? (
          <div>
            <p className={styles.metricLabel}>{minutesLabel}</p>
            <p className={styles.metricValue}>{minutes}</p>
          </div>
        ) : (
          <div />
        )}
        <div className={styles.metricRight}>
          <p className={styles.metricLabel}>Amount</p>
          <p className={styles.metricValue}>{amount}</p>
        </div>
      </div>

      <div className={styles.actions}>
        <button type="button" className={styles.ghostBtn} onClick={onDownload}>
          <DownloadIcon /> Download Invoice
        </button>
        {isUnpaid ? (
          <button type="button" className={styles.primaryBtn} onClick={onPrimary} disabled={busy}>
            {busy ? 'Paying…' : 'Try Again'}
          </button>
        ) : (
          <button type="button" className={styles.outlineBtn} onClick={onPrimary}>
            View Details
          </button>
        )}
      </div>

      {isUnpaid && message && <p className={styles.payStatus}>{message}</p>}

      {isUnpaid && note && (
        <div className={styles.note}>
          <span className={styles.noteIcon}>i</span>
          <p className={styles.noteText}>{note}</p>
        </div>
      )}
    </div>
  )
}

export default InvoiceCard
